import Icon from 'Components/Icon';
import React from 'react';

const Check = props => <Icon icon={['fas', 'check-circle']} {...props}/>;

export default Check;
